<template>
  <!-- 会议预览 -->
  <div class="conferencePreview">
    <p v-show="state" class="invalid">该页面为预览效果，短期内将会失效</p>
    <div v-if="state" class="content">
      <div class="lift">
        <p>
          <img src="@/assets/img/details/2.png" alt="" />
          <span>收藏</span>
        </p>
        <p>
          <img src="@/assets/img/details/share.png" alt="" />
          <span>分享</span>
        </p>
      </div>
      <div class="centre">
        <ul>
          <li class="One">
            <img v-lazy="`${$global.imgUrl}${previewList.cover}`" alt="" />
          </li>
          <li class="Two">
            <div class="h" v-html="previewList.title"></div>
            <div>
              <img src="@/assets/img/qietu/meetIcon.png" alt="" />
              <span>
                <span>主办单位：</span>
                <span
                  style="margin-right: 10px"
                  v-for="item in previewList.organizerList"
                  :key="item.id"
                  >{{ item.name }}</span
                >
              </span>
            </div>
            <div>
              <img src="@/assets/img/qietu/meetIcon1.png" alt="" />
              <span>
                <span>时间：</span>
                <span v-if="previewList.beginTime">{{
                  previewList.beginTime.slice(0, 10)
                }}</span>
              </span>
            </div>
            <div>
              <img src="@/assets/img/qietu/meetIcon2.png" alt="" />
              <span>
                <span>地点：</span>
                <span
                  >{{ previewList.province }} {{ previewList.city }}
                  {{ previewList.address }}</span
                >
              </span>
            </div>
            <div v-if="previewList.coOrganizerList && previewList.coOrganizerList.length > 0">
              <img src="@/assets/img/qietu/meetIcon3.png" alt="" />
              <span>
                <span>协办单位：</span>
                <span
                  style="margin-right: 10px"
                  v-for="item in previewList.coOrganizerList"
                  :key="item.id"
                  >{{ item.name }}</span
                >
              </span>
            </div>
            <div v-if="previewList.undertakerList && previewList.undertakerList.length > 0">
              <img src="@/assets/img/qietu/meetIcon4.png" alt="" />
              <span>
                <span>承办单位：</span>
                <span
                  style="margin-right: 10px"
                  v-for="item in previewList.undertakerList"
                  :key="item.id"
                  >{{ item.name }}</span
                >
              </span>
            </div>
          </li>
          <li class="Three">
            <div
              v-for="(item, index) in previewList.tickets"
              :key="index"
              class="sign"
            >
              <div class="each">
                <div class="left">
                  <div class="h">报名已开启</div>
                  <div class="time">
                    报名时间：{{ item.beginTime }} - {{ item.endTime }}
                  </div>
                  <span class="money"
                    >费用: <span class="num">{{ item.price }}</span></span
                  >
                </div>
                <div class="sign-right">
                  <span class="but">立即报名</span>
                </div>
              </div>
            </div>
          </li>
          <li class="Three">
            <div class="three-title">会议介绍</div>
            <p v-html="previewList.content"></p>
          </li>
          <li class="Three" v-if="previewList.committees && previewList.committees.length > 0">
            <div class="three-title">组委会</div>
            <div class="committee">
              <div
                class="item"
                v-for="item in previewList.committees"
                :key="item.id"
              >
                <div class="left">
                  <img
                    v-if="item.headImg"
                    :src="$global.imgUrl + item.headImg"
                    style="width: 64px; height: 64px; border-radius: 50%"
                    alt=""
                  />
                  <Big
                    v-else
                    width="64"
                    height="64"
                    size="20"
                    :big="item.userName"
                  />
                </div>
                <div class="committee-right">
                  <div>
                    <span class="author">{{ item.userName }}</span>
                    <span class="Position">
                      <span v-for="i in item.titles" :key="i.id"
                        >{{ i.levelTwo }}
                      </span></span
                    >
                  </div>
                  <div v-if="item.orgName" class="site">{{ item.orgName }}</div>
                  <div class="territory" v-if="item.researchDirection">
                    <span>研究方向：{{ item.researchDirection }}</span>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="Three"  v-if="(previewList.edits && previewList.edits.length > 0) || previewList.solicitContent">
            <div class="three-title">征稿信息</div>
            <div
              class="FillingInformation"
              v-for="item in previewList.edits"
              :key="item.id"
            >
              <div class="left">
                <div class="h">{{ item.perName }}</div>
                <div class="bottom">
                  <div class="img">
                    <img :src="$global.imgUrl + item.perImg" alt="" />
                  </div>
                  <div class="detai">
                    <div>
                      <span class="h">{{ item.userName }}</span>
                      <span class="post">{{ item.post }}</span>
                    </div>
                    <div class="phone">{{ item.phone }}</div>
                    <div class="site">{{ item.stampName }}</div>
                    <div class="url">{{ item.website }}</div>
                  </div>
                </div>
              </div>
              <div class="filling-right">
                <div
                  @click="toBusiness(item.userId, item.perId)"
                  class="contribute"
                >
                  <img src="@/assets/img/qietu/tg.png" alt="" />
                  <div>点击投稿</div>
                </div>
                <div class="attention">
                  注意：1、投稿方式：a)在提供的网站上登录后即可在首页提交稿件,b)将论文电子稿发送至邮箱：conf@cqvip.com2、征稿截止日期：2021年12月26日
                </div>
              </div>
            </div>
            <p v-html="previewList.solicitContent" style="margin-top: 30px"></p>
          </li>
        </ul>
      </div>
      <div>
        <div>
          <div class="right">
            <p class="right-1">发布者</p>
            <p class="right-2">
              <img v-lazy="`${$global.imgUrl}${user.headImg}`" alt="" />
              <span>{{ user.name }}</span>
            </p>
            <div class="right-3">
              <span class="wx">
                <span style="fontsize: 18px; color: #ff7d14">0</span>
                <span>文献数</span>
              </span>
              <span class="zx">
                <span style="fontsize: 18px; color: #ff7d14">0</span>
                <span>资讯数</span>
              </span>
            </div>
          </div>
          <div class="right2">
            <div class="h">最新会议</div>
            <div class="list">
              <ul>
                <li v-for="item in wenxian" :key="item.id">
                  <span v-html="item.title"></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="images">
      <img src="@/assets/img/details/urlDisabled.png" alt="" />
      <div>临时链接已失效</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "conferencePreview",
  components: {},
  props: {},
  data() {
    return {
      previewList: {},
      user: {},
      wenxian: {},
      state: true,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.setPreview();
  },
  mounted() {},
  methods: {
    // 获取预览详情
    async setPreview() {
      const resp = await this.$apis.userServe.articlePreview({
        articleId: this.$route.query.articleId,
      });
      if (resp.resultCode == 200) {
        this.previewList = resp.data;
        this.getAuthor();
        this.getPublisher();
      } else {
        this.state = false;
      }
    },
    // 获取发布者信息
    async getAuthor() {
      const resp = await this.$apis.recomendServe.getAuthor({
        userId: this.previewList.createUser,
        type: this.previewList.userType,
      });
      if (resp.resultCode == 200) {
        this.user = resp.content;
      }
      console.log(resp);
    },
    // 获取最新资讯
    async getPublisher() {
      let obj = {
        companyId: this.previewList.companyId,
        pageNo: 1,
        pageSize: 5,
      };
      const { data } = await this.$apis.recomendServe.getPublisher(obj);
      this.wenxian = data;
      console.log(this.wenxian);
    },
  },
};
</script>

<style scoped lang="scss">
.conferencePreview {
  .invalid {
    margin: 0 auto 50px;
    text-align: center;
    width: 396px;
    height: 45px;
    line-height: 45px;
    background: #f9f9f9;
    border-radius: 4px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #333333;
  }
  .images {
    text-align: center;
    position: relative;
    top: 50px;
    margin-top: 50px;
    & img {
      margin-bottom: 50px;
    }
  }
  .content {
    display: flex;
    justify-content: center;
    .lift {
      margin-right: 40px;
      font-size: 13px;
      p {
        margin-bottom: 44px;
        display: flex;
        flex-direction: column;
        text-align: center;
      }
      p img {
        margin-left: 16px;
        width: 28px;
        height: 28px;
      }
      p span {
        width: 60px !important;
      }
    }
    .centre {
      width: 905px;
      border: 1px solid #a3cbe7;
      border-radius: 10px;
      padding: 25px 25px;
      margin-bottom: 10px;
      .One {
        margin-bottom: 20px;
        & img {
          width: 100%;
          height: 420px;
        }
      }
      .Two {
        .h {
          color: #263d78;
          font-size: 26px;
          font-family: PingFang SC;
          margin-bottom: 20px;
        }
        & div img {
          width: 20px;
          margin-right: 5px;
        }
        & div {
          line-height: 40px;
        }
        & div span :first-child {
          font-weight: bold;
        }
      }
      .Three {
        .three-title {
          font-size: 14px;
          color: #333;
          font-weight: bold;
          margin: 20px 0;
        }
        // & div {
        //   font-size: 18px;
        //   line-height: 35px;
        // }

        .sign {
          margin-top: 25px;
          margin-bottom: 20px;
          position: relative;
          .each {
            width: 100%;
            height: 90px;
            padding: 0 20px;
            background: #e0ebff;
            border-radius: 10px;
            display: flex;
            justify-content: space-between;
            .left {
              margin-top: 15px;
              line-height: 30px;
              .h {
                font-size: 16px;
                color: #0344a1;
                font-weight: 700;
              }
              .time {
                font-size: 12px;
                color: #333333;
              }
              .money {
                display: inline;
                vertical-align: top;
                position: relative;
                left: 400px;
                top: -45px;
                .num {
                  width: 100px;
                  font-size: 18px;
                  position: relative;
                  top: 2px;
                }
              }
            }
            .sign-right {
              line-height: 90px;
              .but {
                display: inline-block;
                width: 110px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                margin-top: 25px;
                background: #4585f5;
                border-radius: 5px;
                color: #fff;
                cursor: pointer;
              }
            }
          }
        }
        .committee {
          display: flex;
          flex-wrap: wrap;
          // justify-content:space-between;
          margin-bottom: 30px;
          padding: 0 30px;
          width: 100%;
          img {
            width: 55px;
            height: 55px;
          }
          .item {
            display: flex;
            width: 310px;
            margin-bottom: 70px;
            margin-right: 20px;
            .left {
              margin-right: 10px;
            }
            .committee-right {
              color: #333333;
              .author {
                display: inline-block;
                max-width: 75px;
                font-size: 18px;
                color: #263d78;
                font-weight: bold;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .Position {
                display: inline-block;
                max-width: 125px;
                color: #1876f0;
                margin-left: 24px;
                position: relative;
                top: -2px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .site {
                width: 230px;
                margin-top: 5px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .territory {
                width: 230px;
                margin-top: 5px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
        }
        .FillingInformation {
          width: 100%;
          margin-top: 30px;
          display: flex;
          .left {
            width: 350px;
            height: 200px;
            padding: 20px 25px;
            background-image: url("~@/assets/img/qietu/mp.png");
            border: 1px solid #33333321;
            border-top: none;
            border-radius: 10px;
            .h {
              font-size: 25px;
              color: #333333;
              font-weight: bold;
            }
            .bottom {
              margin-top: 20px;
              display: flex;
              .img {
                width: 70px;
                height: 95px;
                box-shadow: 5px 5px 10px rgb(200, 200, 255);
                img {
                  width: 70px;
                  height: 95px;
                }
              }
              .detai {
                margin-left: 10px;
                .h {
                  display: inline-block;
                  max-width: 80px;
                  font-size: 18px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  word-break: break-word;
                }
                .post {
                  position: relative;
                  top: -3px;
                  display: inline-block;
                  margin-left: 20px;
                  max-width: 130px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  word-break: break-word;
                }
                .phone {
                  width: 230px;
                  font-size: 12px;
                  margin: 5px 0;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  word-break: break-word;
                }
                .site,
                .url {
                  width: 230px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  word-break: break-word;
                }
              }
            }
          }
          .filling-right {
            padding: 10px 30px;
            .contribute {
              width: 80px;
              height: 110px;
              cursor: pointer;
              img {
                width: 70px;
                height: 70px;
              }
              div {
                color: #2150cb;
                font-size: 18px;
              }
            }
            .attention {
              width: 328;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              margin-top: 20px;
              font-size: 12px;
            }
          }
        }
      }
    }
    .right {
      width: 270px;
      height: 250px;
      border: 1px solid #a3cbe7;
      border-radius: 10px;
      margin-left: 10px;
      margin-bottom: 10px;
      .right-1 {
        margin: 25px 0 0 20px;
      }
      .right-2 {
        text-align: center;
        img {
          width: 84px;
          height: 84px;
          border-radius: 50px;
        }
        span {
          display: block;
          color: #333333;
          font-weight: bold;
          font-size: 18px;
          margin-top: 15px;
        }
      }
      .right-3 {
        margin-top: 15px;
        display: flex;
        justify-content: space-around;
        font-size: 12px;
        .wx {
          text-align: center;
          display: flex;
          flex-direction: column;
        }
        .zx {
          text-align: center;
          display: flex;
          flex-direction: column;
        }
      }
    }
    .right2 {
      width: 270px;
      border-radius: 10px;
      margin-left: 10px;
      margin-bottom: 10px;
      .h {
        font-size: 18px;
        color: #333;
        padding: 20px 25px;
        font-weight: bold;
        border-bottom: 1px solid #e5e5e5;
      }
      .list {
        ul li {
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          padding-bottom: 20px;
          color: #666;
          border-bottom: 1px dashed #e8e8e8;
          font-size: 12px;
        }
        ul :nth-last-child(1) {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
